export const getPreviewHostOrigin = () => {
    const matches = window.location.origin.match(/\/\/(local\.)?([^:|\/]+)/);
    return window.location.protocol + '//preview.' + matches[matches.length - 1];
};
